import { render } from "./Permission.vue?vue&type=template&id=b2cad784"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"
script.render = render

export default script